module.exports = __webpack_public_path__ + "assets/projects/zissel/hero.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/zissel/hero.jpg
// module id = 59
// module chunks = 0